import tchat from '@amo/core/assets/images/AMO_Icons/Tout-motards.svg';
import _ from 'lodash';
import moment from 'moment';

const RecapPersonne = (props) => {
    const { data } = props;
    const IndexSouscripteur =
        _.get(data, 'DemandeTarif[ListePersonnes][0][ConducteurMineur]') === 'true' ||
        _.get(data, 'DemandeTarif[ListePersonnes][1][Civilite]') === '3'
            ? 1
            : 0;

    const crmMoto = _.get(data, 'DemandeTarif[ListePersonnes][0][ValeurCrmMoto]');

    return (
        <div className="col-lg-4 col-md-6 col-sm-12 border-end mb-3">
            <div className="row">
                <div className="col-2">
                    <img src={tchat} alt="Informations souscripteur" width={30} loading="lazy" />
                </div>
                <div className="col-10 text-start">
                    <p className="f-14 text-primary fw-bold">
                        Mes informations
                    </p>
                    <div className="f-13">
                        <p className="fw-bold">
                            {_.get(data, `DemandeTarif[ListePersonnes][${IndexSouscripteur}][Prenom]`) || ''}
                            {' '}
                            {_.get(data, `DemandeTarif[ListePersonnes][${IndexSouscripteur}][Nom]`)}
                        </p>
                        <p>{_.get(data, 'DemandeTarif[ListePersonnes][0][Email]')}</p>
                        <p>{_.get(data, 'DemandeTarif[ListePersonnes][0][TelFixe]')}</p>
                        <p>{_.get(data, 'DemandeTarif[ListePersonnes][0][Adresse1]')}</p>
                        {_.get(data, 'DemandeTarif[ListePersonnes][0][Adresse2]') && (
                            <p>{_.get(data, 'DemandeTarif[ListePersonnes][0][Adresse2]')}</p>
                        )}
                        <p>
                            {_.get(data, 'DemandeTarif[ListePersonnes][0][CP]')}{' '}
                            {_.get(data, 'DemandeTarif[ListePersonnes][0][Ville]')}
                        </p>
                    </div>

                    <br />
                    <p className="f-14 text-primary fw-bold">
                        Conducteur
                    </p>
                    <div className="f-13">
                        <p>
                            {_.get(data, 'DemandeTarif[ListePersonnes][0][Prenom]')}{' '}
                            {_.get(data, 'DemandeTarif[ListePersonnes][0][Nom]')}
                        </p>
                        {_.map(_.get(data, 'DemandeTarif[ListePersonnes][0][ListePermis]'), (permis, i) => {
                            if (permis?.TypePermis) {
                                return (
                                    <p key={i}>
                                        Permis {permis.TypePermis} (
                                        {moment(permis.DatePermis, 'DD/MM/YYYY').format('L')})
                                    </p>
                                );
                            }
                        })}
                    </div>

                    {crmMoto && (
                        <>
                            <br />
                            <p className="f-14 text-primary fw-bold">
                                Mon bonus moto
                            </p>
                            <div className="f-13">
                                <p>CRM Moto : {crmMoto}</p>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RecapPersonne;
